module.exports = {
  ZephyrDfu: {
    updateFirmware: () => {
      throw new Error('ZephyrDfu is not available in the web build.');
    },
  },
};